  
function get_the_step_no(input){
  const parent_step_no = input.closest(".steps_hidden");          
  const step = parent_step_no.querySelector(".qus-numb");      
  const step_no = Number(step?.innerHTML.trim());  
  return step_no;
}


class stepThreeComponent extends HTMLElement {
  constructor() {
    super();   
          this.addEventListener("change", this.qtynestanzahi.bind(this));           
      }

  connectedCallback() {
     this.qtynestanzahi();
     this.tabData(); 
  }

    qtynestanzahi(event){
      const This = event?.target || this;    
      const parent = This.closest("step-three-component");
      if(!parent) return;
      const parent_div = parent.querySelector(".info-content");
      const parent_msgbox_z = parent.querySelector(".info-content .srds_z");
      const parent_msgbox_y = parent.querySelector(".info-content .srdanzahl_y");
      const parent_msgbox_x = parent.querySelector(".info-content .value_x");
      const info_content = parent.querySelector(".info-content");
      const yes_data = info_content.getAttribute("data-yes");
      const no_data = info_content.getAttribute("data-no");
      const bam = parent.closest("configure-form")?.querySelector("step-four-component");
      const qty_bam = bam.querySelector(".quantity__input.qty_range").value;      
      const radio_values = [...parent.querySelectorAll(".radio_btn_pdp:checked")].map(input => input.getAttribute("data-value"));
      const range_values = [...parent.querySelectorAll(".single_range_inp")].reduce((total, input) => total + Number(input.value || 0), 0);
     
      
      if(parent_msgbox_z && parent_msgbox_y && parent_msgbox_x){
        if (!window.selected_data || typeof window.selected_data !== "object") {
          window.selected_data = {};
        }  

        if(radio_values[0] == "ja" ){
          parent_msgbox_z.innerText =  Math.round(range_values / 2);
          parent_msgbox_x.innerText = yes_data;  
          window.selected_data["Bam"] = Math.round(qty_bam);                       
        }else if(radio_values[0] == "nein"){
          parent_msgbox_z.innerText = range_values;
          parent_msgbox_x.innerText = no_data;
          window.selected_data["Bam"] = Math.round(Number(qty_bam) / 2);                   
        }
        
           
        window.selected_data["Nestanzahl"] = range_values;
        window.selected_data["Nestintegration"] = radio_values[0];
        window.selected_data["N"] = parent_msgbox_z.innerText;    
           const store_val = {
            notifiBtnData: parent_div.innerText,            
            que_title: parent_div.closest(".cust-form-wrapp")
              ?.querySelector(".qus-sub-heading h2")?.innerHTML || "",
          };

        if(parent_div) localStorage.setItem("notification-text", JSON.stringify(store_val));
      }

       this.tabData();  
       const three_ste = document.querySelector("step-four-component");
       if( typeof three_ste.bamSamVal === "function") three_ste.bamSamVal();
    } 
    
    tabData(){
      // const tab_2_content = document.querySelectorAll('.cricult_tab_2_data.cricult_tab_data'); 
      // const tab_2 = document.querySelectorAll(".cricult_tab_2.cricult_tab.button");      
      //       if (window.selected_data?.Nestintegration === "ja") {
      //          [...tab_2_content].map(el => {el.classList.remove("hidden")});
      //          [...tab_2].map(el => {el.classList.remove("hidden")});                 
      //       }else if (window.selected_data?.Nestintegration === "nein") {
      //           [...tab_2_content].map(el => {el.classList.add("hidden")});
      //           [...tab_2].map(el => {el.classList.add("hidden")});  
      //       }
    }
}
if (!customElements.get('step-three-component')) {
   customElements.define("step-three-component", stepThreeComponent);
}



class stepFourComponent extends HTMLElement {
    constructor() {
          super();   
          this.addEventListener("change", this.bamSamVal.bind(this));
      }

      connectedCallback() {
        this.bamSamVal();
        this.tabData();  
      }

      async bamSamVal(event){
          const This = event?.target || this;    
          const parent = This.closest('step-four-component');
          const is_hall = [...parent.querySelectorAll(".qty_with_range")].reduce((total, input) => total + Number(input.value || 0), 0);
          const is_analog = [...parent.querySelectorAll(".qty_with_range_inp")].reduce((total, input) => total + Number(input.value || 0), 0);
          const is_mkanalanzahl = [...parent.querySelectorAll(".qty_text")].reduce((total, input) => total + Number(input.value || 0), 0);
          console.log("is_mkanalanzahl",is_mkanalanzahl);
          const productData = {
            one_bam: "[data-one-bam-product]",
            two_bam: "[data-two-bam-product]",
            one_sam: "[data-one-sam-product]",
            one_sam_bam: "[data-one-bam-sam-product]",
            srd: "[data-srd-product]",
            bam: "[data-bam-product]",
            sam: "[data-sam-product]"
          };

          Object.entries(productData).forEach(([key, selector]) => {
            const el = parent.querySelector(selector);
            if (el) {
              window.selected_data[key] = el.getAttribute(
                `data-${key.replaceAll("_", "-")}-product`
              );
            }
          });
          if(!parent) return;          
          
            const nestintegration = window.selected_data?.Nestintegration;  
            if(is_analog) window.selected_data["AnalogD"] = is_analog;          
            if(is_mkanalanzahl) window.selected_data["MKanalanzahl"] = is_mkanalanzahl;                 
            if(is_hall) window.selected_data["HallD"] = is_hall;
                if (nestintegration === "ja") {
                  window.selected_data["Bam"] = Math.round(is_hall);            
                  window.selected_data["max"] = Math.round((44 - window.selected_data["AnalogD"] - [window.selected_data["Bam"] * 2])/2);    
                  // window.selected_data["Sam"] = Math.ceil(Math.abs((([window.selected_data["MKanalanzahl"] + window.selected_data["AnalogD"]] * 2) - (window.selected_data["Bam"] * 2)) / 4));          
                  window.selected_data["Sam"] = Math.round((([window.selected_data["MKanalanzahl"] + window.selected_data["AnalogD"]] * 2) - (window.selected_data["Bam"] * 2)) / 4);                            
                } else if (nestintegration === "nein") {
                  window.selected_data["Bam"] = Math.round(Number(is_hall) / 2);
                  window.selected_data["max"] = Math.round(44 - window.selected_data["AnalogD"] - [window.selected_data["Bam"] * 2]);    
                  window.selected_data["Sam"] = ((window.selected_data["MKanalanzahl"] + window.selected_data["AnalogD"]) - (window.selected_data["Bam"] * 2) ) / 4;          
                  // window.selected_data["Bam"] = This.value / 2;
                }

            parent?.querySelectorAll(".qty_text")?.forEach(el => {el.setAttribute("max", window.selected_data["max"]);});
            

            parent?.querySelectorAll(".tooltip-text .max-qty-tool")?.forEach(el => {        
              el.textContent = window.selected_data["max"];
            });
                  
              const error_msg = this.querySelector(".qty_error");
              const max_no_set = error_msg.querySelector("span");
              if(max_no_set) max_no_set.innerHTML= window.selected_data["max"];
                if(is_mkanalanzahl == window.selected_data["max"]){
                  error_msg?.classList.remove("hidden");
                }else{
                  error_msg?.classList.add("hidden");
                }

                parent?.querySelectorAll(".qty_text")?.forEach(el => {
                  if (Number(el.value) > window.selected_data["max"]) {
                    el.value = window.selected_data["max"];
                  }
                });
            
                // window.selected_data["kartensumme"] = window.selected_data["Bam"] + window.selected_data["Sam"];                                   
                window.selected_data["kartensumme"] = window.selected_data["Bam"] + window.selected_data["Sam"];
                const dataProduct = parent.querySelector(".main-products_image .main-product-plan");            
                const lessPro = parent.querySelector(".less_then_two");
                const greaterPro = parent.querySelector(".greter_then_two");
                const productName = dataProduct.name;
                const stepNo = get_the_step_no(dataProduct);
                const kartensumme = window.selected_data["kartensumme"];

                const is_name_skip =  true;
                const bam = Math.floor(Number(window.selected_data["Bam"]) || 0);
                const sam = Math.floor(Number(window.selected_data["Sam"]) || 0); 
                const srdQty = Math.floor(Number(window.selected_data["Nestanzahl"]) || 0);
                const bamQty = Math.floor(Number(window.selected_data["Bam"]) || 0);
                const samQty = Math.floor(Number(window.selected_data["Sam"]) || 0); 
                // const totalProducts = Number(bamQty || 0) + Number(samQty || 0);
                               

                //   const preProductsHutschiene = [
                //       {
                //         handle: "data-bam-Hutschiene",
                //         id: "data-bam-Hutschiene-id",
                //         img: "data-bam-Hutschiene-img"
                //       },
                //       {
                //         handle: "data-sam-Hutschiene",
                //         id: "data-sam-Hutschiene-id",
                //         img: "data-sam-Hutschiene-img"
                //       }                  
                //   ];

                //   const preProductsNine = [
                //       {
                //         handle: "data-bam-nineteen",
                //         id: "data-bam-nineteen-id",
                //         img: "data-bam-nineteen-img"
                //       },
                //       {
                //         handle: "data-sam-nineteen",
                //         id: "data-sam-nineteen-id",
                //         img: "data-sam-nineteen-img"
                //       }                  
                //   ];
          
                const renderProducts = products => {
                  products
                    .filter(({ handle, quantity }) => handle && quantity > 0)
                    .forEach(({ handle, quantity , name }) => {
                      renderSelectedProductsGlobal(
                        handle,
                        name,
                        quantity,
                        stepNo,
                        is_name_skip,
                        window.selected_data["SRDTyp"]
                      );
                    });
                };

                let varData = "";
                parent?.parentElement?.querySelectorAll("[data-srd-product-input]").forEach(input => input.remove());

                if (kartensumme <= 2) {
                  console.log("inside the if");
                  window.selected_data["SRDTyp"] = "Hutschiene";             
                  if (lessPro) {                 
                      lessPro?.classList.remove("hidden");
                      greaterPro?.classList.add("hidden");
                      const lessPro_var_id = lessPro.getAttribute("")
                      varData = lessPro?.dataset.var || "";

                        // BAM/SAM combination -> dynamic HTML attribute
                        // const productSelectors = {
                        //   "1-0": "[data-one-bam-product]",
                        //   "2-0": "[data-two-bam-product]",
                        //   "0-1": "[data-one-sam-product]",
                        //   "0-2": "[data-two-sam-product]",
                        //   "1-1": "[data-one-bam-sam-product]"
                        // };
                        const productSelectors = {
                          "1-0": {
                            selector: "[data-one-bam-product]",
                            handleAttr: "data-one-bam-product",
                            variantAttr: "data-one-bam-product-id"
                          },
                          "2-0": {
                            selector: "[data-two-bam-product]",
                            handleAttr: "data-two-bam-product",
                            variantAttr: "data-two-bam-product-id"
                          },
                          "0-1": {
                            selector: "[data-one-sam-product]",
                            handleAttr: "data-one-sam-product",
                            variantAttr: "data-one-sam-product-id"
                          },
                          "0-2": {
                            selector: "[data-two-sam-product]",
                            handleAttr: "data-two-sam-product",
                            variantAttr: "data-two-sam-product-id"
                          },
                          "1-1": {
                            selector: "[data-one-bam-sam-product]",
                            handleAttr: "data-one-bam-sam-product",
                            variantAttr: "data-one-bam-sam-product-id"
                          }
                        };

                        const config = productSelectors[`${bam}-${sam}`];
                        if (config) {
                          const product = parent.querySelector(config.selector);
                          if (product) {
                            const handle = product.getAttribute(config.handleAttr);
                            const variantId = product.getAttribute(config.variantAttr);

                            if (handle && variantId) {
                              renderProducts([
                                {
                                  handle,
                                  quantity: 1,
                                  name: "contact[_product_hutschiene]"
                                }
                              ]);

                              parent.insertAdjacentHTML(
                                "afterend",
                                `
                                  <input
                                    type="hidden"
                                    data-srd-product-input
                                    name="contact[_product_hutschiene]"
                                    value="${variantId}"
                                  >
                                `
                              );
                            }
                          }
                        }                                     
                  }
                } else {
                window.selected_data["SRDTyp"] = '19"';
                  console.log("inside the else");
                  if (greaterPro) {
                    greaterPro.classList.remove("hidden");
                    varData = greaterPro.getAttribute("data-var");

                    const products = [
                      {
                        selector: "[data-srd-product]",
                        handleAttr: "data-srd-product",
                        variantAttr: "data-srd-product-id",
                        quantity: srdQty,
                        name: "contact[_product_Nineteen_srd]"
                      },
                      {
                        selector: "[data-bam-product]",
                        handleAttr: "data-bam-product",
                        variantAttr: "data-bam-product-id",
                        quantity: bamQty,
                        name: "contact[_product_Nineteen_bam]"
                      },
                      {
                        selector: "[data-sam-product]",
                        handleAttr: "data-sam-product",
                        variantAttr: "data-sam-product-id",
                        quantity: samQty,
                        name: "contact[_product_Nineteen_sam]"
                      }
                    ];

                    products.forEach(({ selector, handleAttr, variantAttr, quantity, name }) => {
                        const product = parent.querySelector(selector);                                         
                        const handle = product.getAttribute(handleAttr);
                        const variantId = product.getAttribute(variantAttr);                        
                        renderProducts([
                          {
                            handle,
                            quantity,
                            name
                          }
                        ]);
                        
                        parent.insertAdjacentHTML(
                          "afterend",
                          `
                            <input
                              type="hidden"
                              data-srd-product-input
                              name="${name}"
                              value="${variantId}"
                            >
                          `
                        );
                      });
                  }
                  lessPro?.classList.add("hidden");
                }

                if(varData) dataProduct.value = varData;

                const productImage = document.querySelector('.products_image:not(.hidden)');
                const main_img = productImage.querySelector("img").src;       
                const product_handle = productImage.getAttribute("data-handle-meta");
                const main_parent = productImage.closest("configure-form");
                const wrapper = main_parent?.querySelector(".meta_product_list");            
                if(window.selected_data["main_image"] != main_img) {
                  window.selected_data["main_image"] = main_img;
                  console.log("maibn_image...")
                  canvasSet(window.selected_data["main_image"]); 
                  // localStorage.setItem("show_image_main", JSON.stringify(window.selected_data["main_image"]));                            
                  // const cardEl = await this.metaProductList(product_handle);                                      
                  //   wrapper.innerHTML = cardEl.innerHTML;
                }  
                
                //  if (kartensumme <= 2) {   
                //   const [bamProduct, samProduct] = preProductsHutschiene; 
                //   // BAM products
                //   for (let i = 1; i <= bamQty; i++) {                                           
                //     const img = document.querySelector(`[${bamProduct.id}]`)?.getAttribute(bamProduct.img);       
                //     const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, i, totalProducts);
                //   }
                //   console.log("bamQty",bamQty);
                //   console.log("samQty",samQty);
                //   // SAM products
                //   for (let i = 1; i <= samQty; i++) {
                //     const productIndex = bamQty + i;
                //     const img = document.querySelector(`[${samProduct.id}]`)?.getAttribute(samProduct.img);
                //     const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, productIndex, totalProducts);
                //   }
                // }else{
                //   const [bamProduct, samProduct] = preProductsNine;
                //   for (let i = 1; i <= bamQty; i++) {                                           
                //     const img = document.querySelector(`[${bamProduct.id}]`)?.getAttribute(bamProduct.img);       
                //     const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, i, totalProducts);
                //   }
                //   console.log("bamQty",bamQty);
                //   console.log("samQty",samQty);
                //   // SAM products
                //   for (let i = 1; i <= samQty; i++) {
                //     const productIndex = bamQty + i;
                //     const img = document.querySelector(`[${samProduct.id}]`)?.getAttribute(samProduct.img);
                //     const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, productIndex, totalProducts);
                //   }
                // }
                const info_message_text = this.querySelector(".srdtype-msg");
                info_message_text.innerHTML = window.selected_data["SRDTyp"];

      }

      tabData(){
          // const tab_2_content = document.querySelectorAll('.cricult_tab_2_data.cricult_tab_data'); 
          // const tab_2 = document.querySelectorAll(".cricult_tab_2.cricult_tab button");          
          //       if (window.selected_data?.Nestintegration === "ja") {
          //         [...tab_2_content].map(el => {el.classList.remove("hidden")});
          //         [...tab_2].map(el => {el.classList.remove("hidden")});   
                  
          //       }else if (window.selected_data?.Nestintegration === "nein") {
          //           [...tab_2_content].map(el => {el.classList.add("hidden")});
          //           [...tab_2].map(el => {el.classList.add("hidden")});  
          //       }
      }

     async metaProductList(handle) {
      try {
        const response = await fetch(`/products/${handle}?view=meta_product_list`);
        const productHTML = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(productHTML, 'text/html');
        const mainDivEl = doc.querySelector('.meta_product_list_wrapp');
        if(mainDivEl){
          return mainDivEl;
        }else{
          return null;
        }
        return   
    
      } catch (error) {
        console.error('Error fetching product info:', error);
        return null;
      }
    }
}
if (!customElements.get('step-four-component')) {
    customElements.define("step-four-component", stepFourComponent);
}


class stepFiveComponent extends HTMLElement {
  constructor() {
    super();

    this.quantityMap = {
      "contact[multi_quantity_1]": "Beschleunigung",
      "contact[multi_quantity_2]": "Kraft",
      "contact[multi_quantity_3]": "Spannung",
      "contact[multi_quantity_4]": "Sonstige",
      "contact[multi_quantity_5]": "five"
    };

    this.addEventListener("change", this.multiQty.bind(this));
  }

  connectedCallback() {
    this.multiQty();
  }

  multiQty(event) {
    const nestIntegration = window.selected_data?.Nestintegration;
      if (nestIntegration === "ja") {        
        window.selected_data["MKanal2"] = ((window.selected_data["Bam"] * 2 + window.selected_data["Sam"] * 4) - (window.selected_data["AnalogD"] * 2)) / 2 ;
      } else if (nestIntegration === "nein") {
        window.selected_data["MKanal2"] = (window.selected_data["Bam"] * 2 + window.selected_data["Sam"] * 4) - window.selected_data["AnalogD"];
      }
      
    this.querySelectorAll(".multi_qty_inp")?.forEach(el => {el.setAttribute("max", window.selected_data["MKanal2"]);});

    const inputs = event?.target?.matches(".multi_qty_inp")? [event.target]: this.querySelectorAll(".multi_qty_inp");
      inputs.forEach(input => {
        const key = this.quantityMap[input.name];      
        if (key) window.selected_data[key] = Number(input.value) || 0;
        window.selected_data["Kanalsumme"] = Object.values(this.quantityMap).reduce((sum, key) => sum + (Number(window.selected_data[key]) || 0),0);
      });

    document.querySelectorAll(".max-all-qty-tool").forEach(el => {el.innerHTML = window.selected_data["MKanal2"] || 0;});
    document.querySelectorAll(".total-qty-tool").forEach(el => {el.innerHTML = window.selected_data["Kanalsumme"] || 0;});

    const name = this.querySelector(".max-multi-qty").name;
    let product_id = "";    
    if(window.selected_data["Kanalsumme"] == 1){
      const one_handle = this.querySelector("[data-up-to-one-handle]")?.getAttribute("data-up-to-one-handle");
      product_id = this.querySelector("[data-up-to-one-id]")?.getAttribute("data-up-to-one-id");
      renderSelectedProducts(one_handle, name, window.selected_data["Kanalsumme"], 5);      
    }else if(window.selected_data["Kanalsumme"] == 3){
      const three_handle = this.querySelector("[data-up-to-three-handle]")?.getAttribute("data-up-to-three-handle");
      product_id = this.querySelector("[data-up-to-three-id]")?.getAttribute("data-up-to-three-id");
      renderSelectedProducts(three_handle, name, window.selected_data["Kanalsumme"], 5);            
    }else if(window.selected_data["Kanalsumme"] == 6){
      const six_handle = this.querySelector("[data-up-to-six-handle]")?.getAttribute("data-up-to-six-handle");
      product_id = this.querySelector("[data-up-to-six-id]")?.getAttribute("data-up-to-six-id");
      renderSelectedProducts(six_handle, name, window.selected_data["Kanalsumme"], 5);                  
    }else if(window.selected_data["Kanalsumme"] == 9){
      const nine_handle = this.querySelector("[data-up-to-nine-handle]")?.getAttribute("data-up-to-nine-handle");
      product_id = this.querySelector("[data-up-to-nine-id]")?.getAttribute("data-up-to-nine-id");                  
      renderSelectedProducts(nine_handle, name, window.selected_data["Kanalsumme"], 5);
    }else if(window.selected_data["Kanalsumme"] == 15){
      const fifteen_handle = this.querySelector("[data-up-to-fifteen-handle]")?.getAttribute("data-up-to-fifteen-handle");
      product_id = this.querySelector("[data-up-to-fifteen-id]")?.getAttribute("data-up-to-fifteen-id");
      renderSelectedProducts(fifteen_handle, name, window.selected_data["Kanalsumme"], 5);      
    }    
    const input_val = this.querySelector(".max-multi-qty")?.value;
    if(input_val) input_val = product_id;
    setTabText(window.selected_data["Kanalsumme"]);
  }
}

if (!customElements.get("step-five-component")) {
  customElements.define("step-five-component", stepFiveComponent);
}


function setTabText(sum) {
  const tab_2_content = document.querySelectorAll(".cricult_tab_2_data.cricult_tab_data");
  const tab_text = document.querySelector("[data-default-text]")?.getAttribute("data-default-text");
  const tab_2 = document.querySelectorAll(".cricult_tab_2.cricult_tab.button");

  const nestIntegration = window.selected_data?.Nestintegration;
  const srdTyp = window.selected_data?.SRDTyp;
  
  if (nestIntegration === "ja") {
    tab_2_content.forEach(el => el.classList.remove("hidden"));
    tab_2.forEach(el => el.classList.remove("hidden"));
  } else if (nestIntegration === "nein") {
    tab_2_content.forEach(el => el.classList.add("hidden"));
    tab_2.forEach(el => el.classList.add("hidden"));
  }


  const equipmentData = [
    {
      name: "Hall",
      quantity: Number(window.selected_data["HallD"]) || 0
    },
    {
      name: "Sensor",
      quantity: Number(window.selected_data["AnalogD"]) || 0
    },
    {
      name: "Beschleunigung",
      quantity: Number(window.selected_data["Beschleunigung"]) || 0
    },
    {
      name: "Kraft",
      quantity: Number(window.selected_data["Kraft"]) || 0
    }, 
    {
      name: "Spannung",
      quantity: Number(window.selected_data["Spannung"]) || 0
    },       
    {
      name: "Sonstige",
      quantity: Number(window.selected_data["Sonstige"]) || 0
    }
  ];

  const allTabs = document.querySelectorAll(".cricuit-plan .cricult_tab_data");
  let preselectedCount = 0;
  const total_card = Math.round(window.selected_data["kartensumme"]);
  console.log("total_card")
  if (nestIntegration === "ja") {
    // if (srdTyp === "Hutschiene") {      
      preselectedCount = total_card * 2;
    // } else if (srdTyp === '19"') {
    //   preselectedCount = total_card ;
    // }
  } else if (nestIntegration === "nein") {
    if (srdTyp === "Hutschiene") {
      preselectedCount = total_card * 4;
    } else if (srdTyp === '19"') {
      preselectedCount = total_card * 4;
    }
  }

  allTabs.forEach(tab => {    
    tab.innerHTML = "";
    let count = 1;
    const equipmentList = [];
    equipmentData.forEach(({ name, quantity }) => {
      for (let i = 0; i < quantity; i++) {
        equipmentList.push(name);
      }
    });

    for (let i = 0; i < preselectedCount; i++) {
      const isDefaultText = !equipmentList[i];
      const equipment = equipmentList[i] || tab_text;
      const isTab2 = tab.classList.contains("cricult_tab_2_data");

      tab.insertAdjacentHTML(
        "beforeend",
        `
          <div class="equipment_item ${isTab2 ? "is_green" : ""}">
            <span class="index_equipment">${isDefaultText ? "" : count}</span>
            <span class="equiment_data">${equipment}</span>
          </div>
        `
      );

      count++;
    }

    for (let i = preselectedCount; i < equipmentList.length; i++) {
      const equipment = equipmentList[i];

      tab.insertAdjacentHTML(
        "beforeend",
        `
          <div class="equipment_item">
            <span class="index_equipment">${count}</span>
            <span class="equiment_data">${equipment}</span>
          </div>
        `
      );

      count++;
    }    
  });

  console.log("sum",sum);

  const image_obj = generateOptionData(window.selected_data);
  console.log("image_obj",image_obj)
  window.canvas.getObjects().slice().forEach(function (obj) {
    if (obj.customId && obj.customId.startsWith('text_')) {
        window.canvas.remove(obj);
    }
});

const imagePositionCounters = {};

Object.entries(image_obj).forEach(([key, item]) => {

    const textVal = item.taxt;
    const imagePosition = item.image_position;

    // Default blue color
    const color = item.color || "#0081C8";
    let font_color = "#000000"
    if(color == '#0081C8') font_color = "#ffffff";

    const leftPersentage = 0.65;

    const topPositionjson = {
        1: 0.17,
        2: 0.34,
        3: 0.54,
        4: 0.72
    };

    const blueImg = get_canvas_position(
        imagePosition,
        window.selected_data["kartensumme"],
        window.canvas
    );


    if (!imagePositionCounters[imagePosition]) {
        imagePositionCounters[imagePosition] = 0;
    }

    imagePositionCounters[imagePosition]++;

    const positionInGroup = imagePositionCounters[imagePosition];

    const topPosition = topPositionjson[positionInGroup];

    textGenrate(
        window.canvas,
        blueImg,
        leftPersentage,
        topPosition,
        textVal,
        font_color,
        color
    );

});

if(window.selected_data["Kanalsumme"] == window.selected_data["MKanal2"]){
  document.querySelectorAll(".multi_qty_inp")?.forEach(el => {
    const parent = el.closest("quantity-input");
    parent?.querySelector("[name='plus']")?.classList.add("disabled");
  });
}

// Object.entries(image_obj).forEach(([key, item], i) => {

//     const textVal = item.taxt;
//     const imagePosition = item.image_position;

//     // Default blue color
//     const color = item.color || "#0081C8";

//     const leftPersentage = 0.56;

//     const topPositionjson = {
//         1: 0.13,
//         2: 0.30,
//         3: 0.50,
//         4: 0.68
//     };

//     const blueImg = get_canvas_position(
//         imagePosition,
//         window.selected_data["kartensumme"],
//         window.canvas
//     );

//     // Position inside the current image group: 1, 2, 3, 4
//     const positionInGroup = (i % 4) + 1;

//     const topPosition = topPositionjson[positionInGroup];

//     textGenrate(
//         window.canvas,
//         blueImg,
//         leftPersentage,
//         topPosition,
//         textVal,
//         "#ffffffff",
//         color
//     );

// });






//   const Halld = Math.floor(Number(window.selected_data['HallD']));
//   const AnalogD = Math.floor(Number(window.selected_data['AnalogD']));
//   // let Halld_max = false;
//   // if(Halld > AnalogD){
//   //   Halld_max = true;
//   // }
//   const total =
//     window.selected_data.Nestintegration === "ja"
//       ? Math.max(Halld, AnalogD) * 2
//       : Math.max(Halld, AnalogD);
// console.log("total",total);
//   let tIndex = 0;
//   let chIndex = 0;
//   let count_of_text = 0;

//   const topPositionjson = {
//     1: 0.13,
//     2: 0.30,
//     3: 0.50,
//     4: 0.68
//   };
//   const leftPersentage = 0.56;

//   for (let i = 1; i <= total; i++) {

//     if (window.selected_data.Nestintegration === "ja") {
//       let textVal;

//       // 1, T1, 2, T2, 3, T3...
//       if (i <= AnalogD * 2) {
//         const num = Math.ceil(i / 2);
//         // textVal = i % 2 === 1
//         //   ? `${num}`
//         //   : `T${num}`;
//           if(i % 2 === 1){
//           textVal = `${num}`;
//         } else if(Halld >= num){
//           textVal = `T${num}`;
//         }else{
//           // return;
//         }

//       } else {
//         const num = AnalogD + (i - (AnalogD * 2));
//         console.log("Halld",Halld,"num",num)      
//           if(Halld >= num ){
//             textVal = `T${num}`;
//           }      
//       }
//   if( typeof textVal == 'undefined') textVal = `${i}`;
//       // Every 4 positions → next Blue/Green pair
//       const groupIndex = Math.floor((i - 1) / 4);
//       const positionInGroup = ((i - 1) % 4) + 1;

//       // 1,2 | 3,4 | 5,6 | 7,8...
//       const blueSlot = groupIndex * 2 + 1;
//       const greenSlot = groupIndex * 2 + 2;
//       const topPosition = topPositionjson[positionInGroup];
//       const blueImg = get_canvas_position(
//         blueSlot,
//         window.selected_data["kartensumme"],
//         window.canvas
//       );
//       const greenImg = get_canvas_position(
//         greenSlot,
//         window.selected_data["kartensumme"],
//         window.canvas
//       );

//       if (blueImg) {
//         textGenrate(
//           window.canvas,
//           blueImg,
//           leftPersentage,
//           topPosition,
//           textVal,
//           "#ffffffff",
//           "#0081C8"
//         );
//       }

//       if (greenImg) {
//         textGenrate(
//           window.canvas,
//           greenImg,
//           leftPersentage,
//           topPosition,
//           textVal,
//           "#000000",
//           "#4ff393"
//         );
//       }
//     }else {

//       const fillColor = "#0081C8";
//       const font_color = "#ffffffff";
//       const maxCount =  Math.max(Halld, AnalogD);

//       if (i <= AnalogD) {
//         chIndex++;
//         count_of_text++;
//         const positionInSlot = ((count_of_text - 1) % 4) + 1;
//         const slot_no = Math.ceil(count_of_text / 4);
//         const topPosition = topPositionjson[positionInSlot];
//         const img_properties =
//           get_canvas_position(
//             slot_no,
//             window.selected_data["kartensumme"],
//             window.canvas
//           );

//         if (img_properties) {
//           textGenrate(
//             window.canvas,
//             img_properties,
//             leftPersentage,
//             topPosition,
//             `${chIndex}`,
//             font_color,
//             fillColor
//           );
//         }
//       }


//       if (i <= Halld) {
//         tIndex++;
//         count_of_text++;
//         const positionInSlot = ((count_of_text - 1) % 4) + 1;
//         const slot_no = Math.ceil(count_of_text / 4);
//         const topPosition = topPositionjson[positionInSlot];
//         const img_properties =
//           get_canvas_position(
//             slot_no,
//             window.selected_data["kartensumme"],
//             window.canvas
//           );

//         if (img_properties) {
//           textGenrate(
//             window.canvas,
//             img_properties,
//             leftPersentage,
//             topPosition,
//             `T${tIndex}`,
//             font_color,
//             fillColor
//           );
//         }
//       }

//     }
//   }

}


// function imageData() {
//   window.canvas.getObjects().slice().forEach(function (obj) {
//     window.canvas.remove(obj);
//   });
//   window.last_slot = 0;
//     const preProductsHutschiene = [
//         {
//           handle: "data-bam-Hutschiene",
//           id: "data-bam-Hutschiene-id",
//           img: "data-bam-Hutschiene-img"
//         },
//         {
//           handle: "data-sam-Hutschiene",
//           id: "data-sam-Hutschiene-id",
//           img: "data-sam-Hutschiene-img"
//         }                  
//     ];

//     const preProductsNine = [
//         {
//           handle: "data-bam-nineteen",
//           id: "data-bam-nineteen-id",
//           img: "data-bam-nineteen-img"
//         },
//         {
//           handle: "data-sam-nineteen",
//           id: "data-sam-nineteen-id",
//           img: "data-sam-nineteen-img"
//         }                  
//     ];

//     const bamQty = Math.floor(Number(window.selected_data["Bam"]) || 0);
//     const samQty = Math.floor(Number(window.selected_data["Sam"]) || 0); 
//     const totalProducts = Number(bamQty || 0) + Number(samQty || 0);
//     const kartensumme = window.selected_data["kartensumme"];

//     if (kartensumme <= 2) {   
//       const [bamProduct, samProduct] = preProductsHutschiene; 
//       // BAM products
//       for (let i = 1; i <= bamQty; i++) {                                           
//         const img = document.querySelector(`[${bamProduct.id}]`)?.getAttribute(bamProduct.img);       
//         const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, i, totalProducts);
//       }
//       console.log("bamQty",bamQty);
//       console.log("samQty",samQty);
//       // SAM products
//       for (let i = 1; i <= samQty; i++) {
//         const productIndex = bamQty + i;
//         const img = document.querySelector(`[${samProduct.id}]`)?.getAttribute(samProduct.img);
//         const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, productIndex, totalProducts);
//       }
//     }else{
//       const [bamProduct, samProduct] = preProductsNine;
//       for (let i = 1; i <= bamQty; i++) {                                           
//         const img = document.querySelector(`[${bamProduct.id}]`)?.getAttribute(bamProduct.img);       
//         const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, i, totalProducts);
//       }
//       console.log("bamQty",bamQty);
//       console.log("samQty",samQty);
//       // SAM products
//       for (let i = 1; i <= samQty; i++) {
//         const productIndex = bamQty + i;
//         const img = document.querySelector(`[${samProduct.id}]`)?.getAttribute(samProduct.img);
//         const canvas_groupid = uploadImageFromURLAnovis(window.canvas, img, productIndex, totalProducts);
//       }
//     }
//      document.querySelectorAll(".multi_qty_inp").forEach(input => {
//       input.value = 0;
//     });

//     window.selected_data["Beschleunigung"] = 0;
//     window.selected_data["Kraft"] = 0;
//     window.selected_data["Spannung"] = 0;
//     window.selected_data["Sonstige"] = 0;
//     window.selected_data["Kanalsumme"] = 0;

//   setTabText(totalProducts);
// }


     
    async function imageData() {

        window.canvas.getObjects().slice().forEach(function (obj) {
            window.canvas.remove(obj);
        });

        window.last_slot = 0;

        const preProductsHutschiene = [
            {
                handle: "data-bam-Hutschiene",
                id: "data-bam-Hutschiene-id",
                img: "data-bam-Hutschiene-img"
            },
            {
                handle: "data-sam-Hutschiene",
                id: "data-sam-Hutschiene-id",
                img: "data-sam-Hutschiene-img"
            }
        ];

        const preProductsNine = [
            {
                handle: "data-bam-nineteen",
                id: "data-bam-nineteen-id",
                img: "data-bam-nineteen-img"
            },
            {
                handle: "data-sam-nineteen",
                id: "data-sam-nineteen-id",
                img: "data-sam-nineteen-img"
            }
        ];

        const bamQty = Math.floor(
            Number(window.selected_data["Bam"]) || 0
        );

        const samQty = Math.floor(
            Number(window.selected_data["Sam"]) || 0
        );

        const totalProducts = bamQty + samQty;

        const kartensumme =
            Number(window.selected_data["kartensumme"]) || 0;

        const uploadPromises = [];

        const products =
            kartensumme <= 2
                ? preProductsHutschiene
                : preProductsNine;

        const [bamProduct, samProduct] = products;

        // ==========================================
        // BAM
        // ==========================================

        for (let i = 1; i <= bamQty; i++) {

            const img = document
                .querySelector(`[${bamProduct.id}]`)
                ?.getAttribute(bamProduct.img);

            console.log("BAM", i, img);

            if (img) {

                uploadPromises.push(
                    uploadImageFromURLAnovis(
                        window.canvas,
                        img,
                        i,
                        totalProducts
                    )
                );
            }
        }

        // ==========================================
        // SAM
        // ==========================================

        for (let i = 1; i <= samQty; i++) {

            const productIndex = bamQty + i;

            const img = document
                .querySelector(`[${samProduct.id}]`)
                ?.getAttribute(samProduct.img);

            console.log("SAM", productIndex, img);

            if (img) {

                uploadPromises.push(
                    uploadImageFromURLAnovis(
                        window.canvas,
                        img,
                        productIndex,
                        totalProducts
                    )
                );
            }
        }

        console.log(
            "Total image uploads:",
            uploadPromises.length
        );

        // ==========================================
        // WAIT FOR ALL IMAGES
        // ==========================================

        try {

            const results = await Promise.all(uploadPromises);

            console.log(
                "ALL IMAGES COMPLETED:",
                results
            );

        } catch (error) {

            console.error(
                "Image loading failed:",
                error
            );

            return;
        }

        // ==========================================
        // NOW ALL IMAGES ARE FINISHED
        // ==========================================

        console.log(
            "Calling setTabText:",
            totalProducts
        );

        document
            .querySelectorAll(".multi_qty_inp")
            .forEach(input => {
                input.value = 0;
            });

        window.selected_data["Beschleunigung"] = 0;
        window.selected_data["Kraft"] = 0;
        window.selected_data["Spannung"] = 0;
        window.selected_data["Sonstige"] = 0;
        window.selected_data["Kanalsumme"] = 0;

        // ==========================================
        // THIS IS LAST
        // ==========================================

        setTabText();
    }



function tabActive(This) {
  const parent = This.closest(".circuit-digram-plan");
  if(!parent) return;
  parent?.querySelectorAll(".cricult_tab.active")?.forEach(element => {
    element.classList.remove("active");
  });
  parent?.querySelectorAll(".cricult_tab_data.active")?.forEach(element => {
    element.classList.remove("active");
  });
  This.classList.add("active");
  parent.querySelector(`${This.getAttribute("data-content")}`)?.classList.add("active");  
}


async function selectedMultiProductShow(handle) {
  try {
    const response = await fetch(`/products/${handle}?view=multi_content`);
    const productHTML = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(productHTML, 'text/html');
    const mainDivEl = doc.querySelector('.multi_product_info');
    if(mainDivEl){
      return mainDivEl;
    }else{
      return null;
    }
    return   

  } catch (error) {
    console.error('Error fetching product info:', error);
    return null;
  }
}


function renderSelectedProductscheckbox(jaHandles,neinHandles,name,input_val,step_no,isChecked,inputNo) {
  const quantity = Number(input_val) || 1;
  const jaProducts = String(jaHandles || "")
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);

  const neinProducts = String(neinHandles || "")
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);

  let products = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
  /* Remove this input number from ALL existing products. */
  products.forEach(product => {
    if (product.name == name) {     
      product.input_no = (product.input_no || [])
        .filter(no => String(no) !== String(inputNo));
      /* Quantity = number of inputs using this product */
      product.quantity = product.input_no.length;
    }
  });

  /* Remove products that no longer belong to any input.*/
  // products = products.filter(product => {
  //   return product?.input_no?.length > 0;
  // });

  const productsToAdd = isChecked
    ? [...new Set(jaProducts)]
    : [...new Set(neinProducts)];

  productsToAdd.forEach(handle => {
    const existingProduct = products?.find(product => product.handle === handle);

    if (existingProduct) {
      if (!existingProduct.input_no.includes(String(inputNo))) {
        existingProduct.input_no.push(String(inputNo));
      }
      existingProduct.quantity = existingProduct.input_no.length;
    } else {
      products.push({
        handle: handle,
        name: name,
        quantity: 1,
        step_no: step_no,
        input_no: [String(inputNo)]
      });

    }  
  });

  localStorage.setItem("selectedProducts",JSON.stringify(products));
  localStorage.setItem("resultProduct",JSON.stringify(products));
}


function saveAndDisplay(container, storageKey, title, values = null) {
  const data = JSON.parse(localStorage.getItem(storageKey) || "[]");
  const idx = data.findIndex(item => item.title === title);
  if (idx > -1) {
    data[idx].values = values;
  } else {
    data.push({ title, values });
  }
  localStorage.setItem(storageKey, JSON.stringify(data));

  // const valueText = Object.entries(values)
  //   .map(([k, v]) => `${k} = ${v}`)
  //   .join(", ");

  // if (values && (Array.isArray(values) || typeof values === "object")) {
  //   valueText = Object.entries(values).map(([k, v]) => `${k} = ${v}`).join(", ");
  // } else {
  //   valueText = values;
  // }
  let valueText = null;

  if (values !== null && values !== undefined) {
    if (Array.isArray(values) || typeof values === "object") {
      valueText = Object.entries(values)
        .map(([k, v]) => `${k} = ${v}`)
        .join(", ");
    } else {
      valueText = values;
    }
  }


  let li = container?.querySelector(`li[data-title="${title}"]`);
  if (!li) {
    li = document.createElement("li");
    li.setAttribute("data-title", title);
    container?.appendChild(li);
  }

  // li.innerHTML = `<p>${title}</p>
  //   <p>${valueText}</p>`;
    li.innerHTML = `
      <p>${title}</p>
      ${values !== null && values !== undefined
        ? `<p>${valueText}</p>`
        : ""
      }
    `;
}  


// ==== CHECKBOX RESULT =====
  const checkboxContainer = document.querySelector(".hardware_pdp_checkbox");
  if (checkboxContainer) checkboxContainer.innerHTML = "";
    // localStorage.removeItem("checkbox_info");
    const single_checkbox = document.querySelectorAll(".single_checkbox");
    single_checkbox?.forEach(group => {
      const titleEl = group.querySelector(".quetion_text");
      if (!titleEl) return;
      const title = titleEl.textContent.trim();
    
      const checkboxes = group.querySelectorAll('input.checkbox-plan-pdp');
      if (!checkboxes.length) return;
    
      const parent = group.closest(".quetion_checkbox");


      const update = () => {
        const checkedValues = Array.from(checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.value);
    
        if (checkedValues.length > 0) {
          saveAndDisplay(checkboxContainer, "checkbox_info", title, checkedValues);
        } else {
          // remove entry if nothing checked
          const data = JSON.parse(localStorage.getItem("checkbox_info") || "[]");
          const idx = data.findIndex(item => item.title === title);
          if (idx > -1) {
            data.splice(idx, 1);
            localStorage.setItem("checkbox_info", JSON.stringify(data));
          }
          const el = checkboxContainer?.querySelector(`[data-title="${title}"]`);
          if (el) el.remove();
        }
      };
    
      checkboxes.forEach(cb => cb.addEventListener("change", update));
      update(); 
  });


function updateCheckboxProduct(checkbox) {
  const parent = checkbox.closest(".quetion_checkbox");
  if (!parent) return;

  const productInp = parent.querySelector(".checkbox-plan-product");
  if (!productInp) return;

  const inputNo = checkbox.dataset.inputKey;
  const jaHandles = productInp.dataset.handleJa || "";
  const neinHandles = productInp.dataset.handleNein || "";

  productInp.value = checkbox.checked
    ? productInp.dataset.ja || ""
    : productInp.dataset.nein || "";

  const name = checkbox.name || "";
  const step_no =
    typeof get_the_step_no === "function"
      ? get_the_step_no(checkbox)
      : 0;

  renderSelectedProductscheckbox(
    jaHandles,
    neinHandles,
    name,
    1,
    step_no,
    checkbox.checked,
    inputNo
  );
}

single_checkbox?.forEach(group => {
  group.querySelectorAll(".checkbox-plan-pdp").forEach(checkbox => {
    
    checkbox.addEventListener("change", () => {
      updateCheckboxProduct(checkbox);
    });
    updateCheckboxProduct(checkbox);
  });
});


const accordian_fifth = document.querySelectorAll(".accordion-image-title-content-item .accordion_input.content_show_local");
accordian_fifth?.forEach(input => {
  input.addEventListener("change", function () {
    const wrapper = input.closest(".accordion-image-title-content-item-inner");
    const acc_title = wrapper?.querySelector(".build-title")?.innerHTML?.trim();
    const acc_content = wrapper?.querySelector(".accordion-image-content")?.innerHTML;
    if (!acc_title || !acc_content) return;  
    let acc_stored = JSON.parse(localStorage.getItem("fifth_accordian_info") || "[]");
    const index = acc_stored.findIndex(item => item.acc_title === acc_title);

    if (input.checked) {
      if (index !== -1) {
        acc_stored[index] = {acc_title,acc_content};
      } else {        
        acc_stored.push({acc_title,acc_content});
      }
    } else {      
      if (index !== -1) acc_stored.splice(index, 1);
    }

    localStorage.setItem("fifth_accordian_info",JSON.stringify(acc_stored));


     const currentStep = input.closest('.cust-form-wrapp');
      if (!currentStep) return;      
      const checked = [...currentStep.querySelectorAll(".is_product_in_atc:checked")];
      const unchecked = [...currentStep.querySelectorAll(".is_product_in_atc:not(:checked)")];
      
      const unactive = unchecked.flatMap(el => {
        const name = el.getAttribute("name") || "";
        return (el.getAttribute("pre-selecetd-handle") || "")
          .split(",")
          .filter(Boolean)
          .map(handle => ({ handle, name }));
      });
      
      // build current valid pairs from UI
      const active = checked.flatMap(el => {
        const name = el.getAttribute("name") || "";
        console.log("name..",name);
        return (el.getAttribute("pre-selecetd-handle") || "")
          .split(",")
          .filter(Boolean)
          .map(handle => ({ handle, name }));
      });
      console.log("active",active);
      let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
      // remove unchecked
      stored = stored.filter(item =>!unactive.some(a => a.handle === item.handle && a.name === item.name));
      // add new checked
      active.forEach(a => {
        if (!stored.some(s => s.handle === a.handle && s.name === a.name)) {
          stored.push({ ...a, quantity: 1 });
        }
      });      
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
      localStorage.setItem("resultProduct", JSON.stringify(stored));              

  });
});


// canvas
 function get_canvas_position(position, totalOptions, canvas) {
  if (!canvas || !position || !totalOptions) return null;    
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  // Reserved/skip area on the left
  // 225px based on a 1200px canvas
  
    let baseCanvasWidth = 1200;
    let baseSkipWidth = 223;
    let endskip = 70;
    if(window.selected_data["SRDTyp"] == "Hutschiene"){
      totalOptions = 2;
    }else{
      totalOptions = 13;
    }
   if(canvasWidth <= 500) {
     baseCanvasWidth = 500;
     baseSkipWidth = 168;
     endskip = 0;
  }
  // Make skip area responsive based on canvas width
  const skipWidth = (baseSkipWidth / baseCanvasWidth) * canvasWidth;
  const endskipwidth = (endskip / baseCanvasWidth) * canvasWidth;
  console.log("skipWidth",skipWidth,"endskipwidth",endskipwidth)
  const totalSkipWidth = skipWidth + endskipwidth;
  // Width available for addon options
  const availableWidth = canvasWidth - totalSkipWidth;
  console.log("totalOptions",totalOptions,"totalSkipWidth",totalSkipWidth,"canvasWidth",canvasWidth)
  // Width of each addon option
  const optionWidth = availableWidth / totalOptions;

  // Position of current addon
  const left = skipWidth + ((position - 1) * optionWidth);
  const img_properties = {
    top: 0,
    left: left,
    width: optionWidth,
    height: canvasHeight
  };
  return img_properties;
}

  function renderSelectedProducts(allMetaValues, names, input_val,step_no) {
    
    const quantity = Number(input_val) || 1;
    // Normalize to arrays
    if (!Array.isArray(allMetaValues)) allMetaValues = [allMetaValues];
    if (!Array.isArray(names)) names = [names];
  
    // Remove duplicate handles
    const uniqueHandles = [...new Set(allMetaValues)];
    let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");  

    for (let i = 0; i < uniqueHandles.length; i++) {      
      const handle = uniqueHandles[i];
      const name = names[i] || "";
      const existingIndex = stored.findIndex(item => item.name === name);
      console.log("stored...",stored);
      
      if (existingIndex !== -1) {
        // stored[existingIndex].handle = handle;
        stored[existingIndex] = {
          ...stored[existingIndex],
          handle,
          name,
          quantity,
          step_no
        };
        stored = stored.filter(item => item.step_no !== 4);
      } else {
        stored.push({ handle, name, quantity, step_no });
        
      }
    }
  
    // Step 3: Save updated stored data back to localStorage
    localStorage.setItem("selectedProducts", JSON.stringify(stored));
    localStorage.setItem("resultProduct", JSON.stringify(stored));
  }


  

  
  function generateOptionData(selectedData) {
    const result = {};
    let resultIndex = 1;

    const totalImages =
        (parseInt(selectedData.Bam) || 0) +
        (parseInt(selectedData.Sam) || 0);

    if (totalImages <= 0) {
        return result;
    }

    const nestIntegration =
        String(selectedData.Nestintegration || "").toLowerCase() === "ja";

    /*
     * =====================================================
     * HELPER
     * =====================================================
     */

    function getImageItemCount(imagePosition) {
        return Object.values(result).filter(
            item => item.image_position === imagePosition
        ).length;
    }

    function addItem(value, imagePosition, color = null) {

        if (imagePosition > totalImages) {
            return false;
        }

        if (getImageItemCount(imagePosition) >= 4) {
            return false;
        }

        result[resultIndex++] = {
            taxt: value,
            image_position: imagePosition,
            ...(color ? { color } : {})
        };

        return true;
    }

    /*
     * =====================================================
     * 1. ANALOGD + HALLD
     * =====================================================
     */

    const analogCount = parseInt(selectedData.AnalogD) || 0;
    const hallCount = parseInt(selectedData.HallD) || 0;

    const mainValues = [];

    const maxCount = Math.max(analogCount, hallCount);

    for (let i = 1; i <= maxCount; i++) {

        if (i <= analogCount) {
            mainValues.push(String(i));
        }

        if (i <= hallCount) {
            mainValues.push(`T${i}`);
        }
    }

    /*
     * Split main values into groups of 4.
     */
    const mainGroups = [];

    for (let i = 0; i < mainValues.length; i += 4) {
        mainGroups.push(mainValues.slice(i, i + 4));
    }

    /*
     * =====================================================
     * 2. NORMAL + GREEN FOR MAIN GROUPS
     * =====================================================
     */

    let nextImagePosition = 1;

    mainGroups.forEach(group => {

        if (nextImagePosition > totalImages) {
            return;
        }

        /*
         * NORMAL
         */
        group.forEach(value => {
            addItem(value, nextImagePosition);
        });

        /*
         * GREEN
         */
        if (nestIntegration) {

            let greenImagePosition = nextImagePosition + 1;

            /*
             * If next image does not exist,
             * put green into the SAME image.
             */
            if (greenImagePosition > totalImages) {
                greenImagePosition = nextImagePosition;
            }

            group.forEach(value => {
                addItem(
                    value,
                    greenImagePosition,
                    "#4ff393"
                );
            });

            /*
             * If green is on the next image,
             * move to the image after green.
             *
             * If green is on the same image,
             * move to next image.
             */
            if (greenImagePosition === nextImagePosition) {
                nextImagePosition++;
            } else {
                nextImagePosition += 2;
            }

        } else {
            nextImagePosition++;
        }
    });

    /*
     * =====================================================
     * 3. ADDITIONAL OPTIONS
     *
     * These are processed AFTER AnalogD + HallD.
     * =====================================================
     */

    const additionalOptions = [
        "Beschleunigung",
        "Kraft",
        "Spannung",
        "Sonstige"
    ];

    let additionalCount = 0;

    additionalOptions.forEach(option => {
        additionalCount += parseInt(selectedData[option]) || 0;
    });

    /*
     * Additional numbering starts after AnalogD.
     *
     * AnalogD = 3
     * Beschleunigung = 1
     *
     * => 4
     */
    const additionalValues = [];

    for (let i = 1; i <= additionalCount; i++) {
        additionalValues.push(
            String(analogCount + i)
        );
    }

    /*
     * =====================================================
     * 4. ADDITIONAL VALUES
     *
     * IMPORTANT:
     *
     * First try to use remaining slots in the LAST
     * available image.
     *
     * Example:
     *
     * Image 3:
     *     3
     *     green 3
     *
     * 2 slots remain.
     *
     * Add:
     *     4
     *     green 4
     * =====================================================
     */

    additionalValues.forEach(value => {

        /*
         * Find the last image that has free space.
         */
        let targetImage = null;

        for (let image = totalImages; image >= 1; image--) {

            if (getImageItemCount(image) < 4) {
                targetImage = image;
                break;
            }
        }

        /*
         * No available slot.
         */
        if (!targetImage) {
            return;
        }

        /*
         * Add NORMAL value.
         */
        addItem(value, targetImage);

        /*
         * Add GREEN value.
         *
         * It must also be on the same image if
         * there is still a free slot.
         */
        if (nestIntegration) {

            if (getImageItemCount(targetImage) < 4) {

                addItem(
                    value,
                    targetImage,
                    "#4ff393"
                );
            }
        }
    });

    return result;
}



//   function generateOptionData(selectedData) {

//     const result = {};
//     const items = [];

//     let numberValue = 1;

//     /*
//      * -----------------------------------------
//      * 1. Generate ALL numeric values
//      *
//      * AnalogD
//      * Beschleunigung
//      * Kraft
//      * Spannung
//      * Sonstige
//      * -----------------------------------------
//      */

//     const numericTypes = [
//         "AnalogD",
//         "Beschleunigung",
//         "Kraft",
//         "Spannung",
//         "Sonstige"
//     ];

//     numericTypes.forEach(type => {

//         const count = parseInt(selectedData[type]) || 0;

//         for (let i = 0; i < count; i++) {

//             items.push({
//                 taxt: String(numberValue),
//                 type: "number"
//             });

//             numberValue++;
//         }
//     });


//     /*
//      * -----------------------------------------
//      * 2. Generate HallD T values
//      * -----------------------------------------
//      */

//     const hallCount = parseInt(selectedData.HallD) || 0;

//     const tValues = [];

//     for (let i = 1; i <= hallCount; i++) {

//         tValues.push({
//             taxt: `T${i}`,
//             type: "text"
//         });
//     }


//     /*
//      * -----------------------------------------
//      * 3. Combine numbers + T values
//      *
//      * Example:
//      *
//      * Numbers:
//      * 1,2,3,4,5
//      *
//      * T:
//      * T1,T2
//      *
//      * Result:
//      * 1,T1,2,T2,3,4,5
//      * -----------------------------------------
//      */

//     let tIndex = 0;

//     for (let i = 0; i < items.length; i++) {

//         // Add number
//         const numberItem = items[i];

//         items[i].processed = true;

//         const combinedItem = {
//             taxt: numberItem.taxt,
//             type: "number"
//         };

//         /*
//          * Add number first
//          */
//         // We don't push directly because we need
//         // to create a separate combined array.
//     }

//     const combinedItems = [];

//     /*
//      * Add numbers and T values alternately
//      * while T values are available.
//      */
//     for (let i = 0; i < items.length; i++) {

//         combinedItems.push({
//             taxt: items[i].taxt,
//             type: "number"
//         });

//         if (tIndex < tValues.length) {

//             combinedItems.push({
//                 taxt: tValues[tIndex].taxt,
//                 type: "text"
//             });

//             tIndex++;
//         }
//     }


//     /*
//      * -----------------------------------------
//      * 4. Add any remaining T values
//      * -----------------------------------------
//      */

//     while (tIndex < tValues.length) {

//         combinedItems.push({
//             taxt: tValues[tIndex].taxt,
//             type: "text"
//         });

//         tIndex++;
//     }


//     /*
//      * -----------------------------------------
//      * 5. Create image groups
//      *
//      * Maximum 4 items per image
//      * -----------------------------------------
//      */

//     let resultIndex = 1;
//     let imagePosition = 1;

//     for (let i = 0; i < combinedItems.length; i += 4) {

//         const group = combinedItems.slice(i, i + 4);


//         /*
//          * Normal image
//          */
//         group.forEach(item => {

//             result[resultIndex] = {
//                 taxt: item.taxt,
//                 image_position: imagePosition
//             };

//             resultIndex++;
//         });


//         /*
//          * Green duplicate
//          */
//         if (selectedData.Nestintegration === "ja") {

//             imagePosition++;

//             group.forEach(item => {

//                 result[resultIndex] = {
//                     taxt: item.taxt,
//                     image_position: imagePosition,
//                     color: "#4ff393"
//                 };

//                 resultIndex++;
//             });
//         }


//         /*
//          * Next normal image
//          */
//         imagePosition++;
//     }

//     return result;
// }



//   function generateOptionData(selectedData) {

//     const result = {};

//     let resultIndex = 1;
//     let imagePosition = 1;

//     const items = [];

//     /*
//      * -----------------------------------------
//      * Create numeric values
//      * -----------------------------------------
//      */

//     let numberValue = 1;

//     const numericTypes = [
//         "AnalogD",
//         "Beschleunigung",
//         "Kraft",
//         "Spannung",
//         "Sonstige"
//     ];

//     numericTypes.forEach(type => {

//         const count = parseInt(selectedData[type]) || 0;

//         for (let i = 0; i < count; i++) {

//             items.push({
//                 taxt: String(numberValue),
//                 type: "number"
//             });

//             numberValue++;
//         }
//     });


//     /*
//      * -----------------------------------------
//      * Create T values
//      * -----------------------------------------
//      */

//     const hallCount = parseInt(selectedData.HallD) || 0;

//     const tValues = [];

//     for (let i = 1; i <= hallCount; i++) {
//         tValues.push(`T${i}`);
//     }


//     /*
//      * -----------------------------------------
//      * IMPORTANT:
//      *
//      * First combine:
//      *
//      * 1  -> T1
//      * 2  -> T2
//      * 3  -> T3
//      *
//      * Then remaining T values:
//      *
//      * T4
//      * T5
//      * T6
//      * T7
//      * -----------------------------------------
//      */

//     const combinedItems = [];

//     const pairCount = Math.min(
//         numberValue - 1,
//         tValues.length
//     );

//     for (let i = 0; i < pairCount; i++) {

//         // Number
//         combinedItems.push({
//             taxt: String(i + 1),
//             type: "number"
//         });

//         // T value
//         combinedItems.push({
//             taxt: tValues[i],
//             type: "text"
//         });
//     }


//     /*
//      * Add remaining T values
//      */
//     for (let i = pairCount; i < tValues.length; i++) {

//         combinedItems.push({
//             taxt: tValues[i],
//             type: "text"
//         });
//     }


//     /*
//      * -----------------------------------------
//      * Create image groups
//      *
//      * Maximum 4 items per image
//      * -----------------------------------------
//      */

//     for (let i = 0; i < combinedItems.length; i += 4) {

//         const group = combinedItems.slice(i, i + 4);


//         /*
//          * Normal image
//          */
//         group.forEach(item => {

//             result[resultIndex] = {
//                 taxt: item.taxt,
//                 image_position: imagePosition
//             };

//             resultIndex++;
//         });


//         /*
//          * Green duplicate image
//          */
//         if (selectedData.Nestintegration === "ja") {

//             imagePosition++;

//             group.forEach(item => {

//                 result[resultIndex] = {
//                     taxt: item.taxt,
//                     image_position: imagePosition,
//                     color: "#4ff393"
//                 };

//                 resultIndex++;
//             });
//         }


//         /*
//          * Next normal image
//          */
//         imagePosition++;
//     }


//     return result;
// }